import React, { useState, useEffect, useContext, useMemo } from "react";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import { i18n } from "../../translate/i18n";
import { 
  MenuItem, 
  FormControl, 
  InputLabel, 
  Select, 
  Typography, 
  Box, 
  Paper,
  Chip,
  Link,
  FormHelperText
} from "@material-ui/core";
import { 
  Visibility, 
  VisibilityOff, 
  Memory, 
  Android, 
  Security, 
  Settings,
  OpenInNew,
  AttachFile,
  Link as LinkIcon,
  CloudUpload,
  Fullscreen,
  FullscreenExit,
  Layers,
  Description
} from "@material-ui/icons";
import { InputAdornment, IconButton } from "@material-ui/core";

import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import PromptMediaPreview from "../PromptMediaPreview";
import PromptLayersManager from "../PromptLayersManager";
import PromptDocumentsManager from "../PromptDocumentsManager";
import {
  AI_PROVIDER_MENU_SECTIONS,
  DEFAULT_AI_PROVIDER,
  getApiKeyUi,
  getProviderLabel
} from "../../constants/aiProviderCatalog";
import { useStyles } from "./PromptModalStyles";
import usePromptMedia from "./usePromptMedia";
import usePromptForm from "./usePromptForm";
import {
  getPrompt,
  getPromptMedia,
  uploadPromptMedia,
  deletePromptMedia,
  addPromptMediaUrl,
  validatePromptApi,
  updatePrompt,
  createPrompt,
} from "../../services/prompt.api";
import ExpandedPromptModal from "./ExpandedPromptModal";
import UrlModalContent from "./UrlModalContent";
import PromptMediaSection from "./PromptMediaSection";
import PromptWorkModeSection from "./PromptWorkModeSection";





// initialState + toda la lógica del formulario viven en ./usePromptForm (D8.3.4b)

const PromptModal = ({ open, onClose, promptId, onSave }) => {
    const classes = useStyles();
    const { user } = useContext(AuthContext);
    const {
        mediaFiles, setMediaFiles, loadingMedia, urlModalOpen, setUrlModalOpen,
        isDragging, setIsDragging, mediaMessage, setMediaMessage, fetchMediaFiles,
        handleFileUpload, handleDeleteMedia, handleAddUrl, handleReorder,
    } = usePromptMedia(promptId);
    const fileInputRef = React.useRef(null);
    // D8.3.4b — estado y lógica del formulario extraídos a usePromptForm (media inyectado)
    const {
        selectedVoice, setSelectedVoice,
        showApiKey, setShowApiKey,
        selectedProvider, setSelectedProvider,
        validatingApi, setValidatingApi,
        expandedPromptModalOpen, setExpandedPromptModalOpen,
        expandedPromptText, setExpandedPromptText,
        expandedPromptChanged, setExpandedPromptChanged,
        apiValidated, setApiValidated,
        apiValidationError, setApiValidationError,
        hasStoredApiKey, setHasStoredApiKey,
        savedProvider, setSavedProvider,
        selectedWorkMode, setSelectedWorkMode,
        prompt, setPrompt,
        validationSchema,
        handleToggleApiKey,
        handleChangeProvider,
        handleClose,
        handleValidateApi,
        handleSavePrompt,
    } = usePromptForm({
        promptId,
        open,
        onClose,
        onSave,
        fileInputRef,
        setMediaFiles,
        setUrlModalOpen,
        setIsDragging,
        fetchMediaFiles,
    });

    return (
        <div className={classes.root}>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                scroll="paper"
                fullWidth={false}
                PaperProps={{ style: { width: "840px", maxWidth: "90vw" } }}
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Box display="flex" alignItems="center">
                        <Memory style={{ marginRight: 12, fontSize: 28 }} />
                        <Typography variant="h6">
                            {promptId
                                ? `${i18n.t("promptModal.title.edit")}`
                                : `${i18n.t("promptModal.title.add")}`}
                        </Typography>
                    </Box>
                </DialogTitle>
                
                <Formik
                    initialValues={prompt}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={(values, actions) => {
                        setTimeout(() => {
                            handleSavePrompt(values);
                            actions.setSubmitting(false);
                        }, 400);
                    }}
                >
                    {({ isSubmitting, errors, touched, values, setFieldValue }) => {
                        // ✅ Guardar referencia a setFieldValue para usarla en el modal ampliado
                        window.setFieldValuePrompt = setFieldValue;
                        const apiKeyUi = getApiKeyUi(selectedProvider);
                        
                        return (
                        <Form style={{ width: "100%" }}>
                            <DialogContent className={classes.dialogContent}>
                                
                                {/* ✅ INFORMACIÓN SOBRE PROVEEDOR DE IA */}
                                <Paper className={classes.infoBox}>
                                    <Box display="flex" alignItems="center" marginBottom={1}>
                                        <Android style={{ marginRight: 8, color: "#1976d2" }} />
                                        <Typography variant="h6" style={{ color: "#1976d2", fontWeight: "bold" }}>
                                            <span role="img" aria-label="robot">🤖</span> {i18n.t("promptModal.providerInfo.title")}
                                        </Typography>
                                    </Box>
                                    <Typography className={classes.infoText}>
                                        {i18n.t("promptModal.providerInfo.body1")}
                                    </Typography>
                                    <Typography className={classes.infoText}>
                                        {i18n.t("promptModal.providerInfo.body2")}
                                    </Typography>
                                </Paper>
                                
                                {/* ✅ SECCIÓN: CONFIGURACIÓN DE API */}
                                <Paper className={classes.formSection}>
                                    <Typography className={classes.sectionTitle}>
                                        <Security style={{ marginRight: 8 }} />
                                        {i18n.t("promptModal.sections.api")}
                                    </Typography>
                                    
                                    <FormControl fullWidth margin="dense" variant="outlined" className={classes.formField}>
                                        <TextField
                                            label={apiKeyUi.label}
                                            name="apiKey"
                                            value={values.apiKey || ""}
                                            onChange={(e) => {
                                                const newApiKey = e.target.value;
                                                setFieldValue("apiKey", newApiKey);
                                                const t = newApiKey.trim();
                                                if (t.length > 0) {
                                                    setApiValidated(false);
                                                    setApiValidationError(null);
                                                } else if (
                                                    hasStoredApiKey &&
                                                    selectedProvider === savedProvider
                                                ) {
                                                    setApiValidated(true);
                                                    setApiValidationError(null);
                                                } else {
                                                    setApiValidated(false);
                                                }
                                            }}
                                            type={showApiKey ? "text" : "password"}
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                            error={
                                                (touched.apiKey && Boolean(errors.apiKey)) ||
                                                (apiValidationError && !apiValidated)
                                            }
                                            helperText={
                                                (touched.apiKey && errors.apiKey) ||
                                                (apiValidationError && !apiValidated
                                                    ? apiValidationError
                                                    : "") ||
                                                (apiValidated
                                                    ? i18n.t("promptModal.apiTest.validatedHelper")
                                                    : [
                                                          hasStoredApiKey &&
                                                          !(values.apiKey && String(values.apiKey).trim())
                                                              ? i18n.t(
                                                                    "promptModal.apiTest.storedKeyHelper"
                                                                )
                                                              : "",
                                                          apiKeyUi.helper
                                                      ]
                                                          .filter(Boolean)
                                                          .join(" "))
                                            }
                                            placeholder={
                                                hasStoredApiKey &&
                                                !(values.apiKey && String(values.apiKey).trim())
                                                    ? i18n.t(
                                                          "promptModal.apiTest.storedKeyMaskPlaceholder"
                                                      )
                                                    : apiKeyUi.placeholder
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton onClick={handleToggleApiKey}>
                                                            {showApiKey ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </FormControl>
                                    
                                    <FormControl fullWidth margin="dense" variant="outlined" className={`${classes.formField} ${classes.formControlDynamic}`}>
                                        <InputLabel>{i18n.t("promptModal.fields.aiProvider")}</InputLabel>
                                        <Select
                                            id="provider-select"
                                            labelWidth={120}
                                            name="provider"
                                            label={i18n.t("promptModal.fields.aiProvider")}
                                            value={selectedProvider}
                                            onChange={(e) => {
                                                const v = e.target.value;
                                                setFieldValue("provider", v);
                                                handleChangeProvider(e, values.apiKey);
                                            }}
                                            multiple={false}
                                        >
                                            {AI_PROVIDER_MENU_SECTIONS.flatMap(
                                                (section, sectionIdx) => [
                                                    <MenuItem
                                                        key={`section-${section.header}`}
                                                        disabled
                                                        style={{
                                                            backgroundColor: "#f5f5f5",
                                                            fontWeight: "bold",
                                                            color: "#333",
                                                            marginTop:
                                                                sectionIdx > 0 ? "8px" : 0
                                                        }}
                                                    >
                                                        {section.header}
                                                    </MenuItem>,
                                                    ...section.items.map((item) => (
                                                        <MenuItem
                                                            key={item.value}
                                                            value={item.value}
                                                        >
                                                            <Box
                                                                display="flex"
                                                                alignItems="center"
                                                            >
                                                                <Chip
                                                                    label={item.chip}
                                                                    size="small"
                                                                    className={
                                                                        item.useProviderChipClass
                                                                            ? classes.providerChip
                                                                            : undefined
                                                                    }
                                                                    style={
                                                                        item.chipStyle ||
                                                                        undefined
                                                                    }
                                                                />
                                                                <Typography
                                                                    style={{ marginLeft: 8 }}
                                                                >
                                                                    {getProviderLabel(
                                                                        item.value
                                                                    )}
                                                                </Typography>
                                                            </Box>
                                                        </MenuItem>
                                                    ))
                                                ]
                                            )}
                                        </Select>
                                    </FormControl>
                                    
                                    {/* ✅ Botón de validación debajo del Proveedor de IA */}
                                    <Box marginTop={1} display="flex" justifyContent="flex-end">
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            color={apiValidated ? "primary" : "default"}
                                            onClick={() => handleValidateApi(values.apiKey)}
                                            disabled={
                                                validatingApi ||
                                                !selectedProvider ||
                                                !(values.apiKey && String(values.apiKey).trim())
                                            }
                                            startIcon={validatingApi ? <CircularProgress size={16} /> : (apiValidated ? <Security style={{ color: "green" }} /> : <Security />)}
                                        >
                                            {validatingApi ? i18n.t("promptModal.apiTest.validating") : apiValidated ? i18n.t("promptModal.apiTest.validated") : i18n.t("promptModal.apiTest.testConnection")}
                                        </Button>
                                    </Box>
                                </Paper>
                                
                                {/* ✅ SECCIÓN: INFORMACIÓN BÁSICA */}
                                <Paper className={classes.formSection}>
                                    <Typography className={classes.sectionTitle}>
                                        <Memory style={{ marginRight: 8 }} />
                                        {i18n.t("promptModal.sections.basic")}
                                    </Typography>
                                    
                                    <TextField
                                        label={i18n.t("promptModal.fields.promptName")}
                                        name="name"
                                        value={values.name || ""}
                                        onChange={(e) => setFieldValue('name', e.target.value)}
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        className={classes.formField}
                                        error={touched.name && Boolean(errors.name)}
                                        helperText={(touched.name && errors.name) || i18n.t("promptModal.fields.promptNameHelper")}
                                        placeholder={i18n.t("promptModal.fields.promptNamePlaceholder")}
                                    />
                                    
                                    <TextField
                                        label={i18n.t("promptModal.fields.mainPrompt")}
                                        name="prompt"
                                        value={values.prompt || ""}
                                        onChange={(e) => setFieldValue('prompt', e.target.value)}
                                        variant="outlined"
                                        margin="dense"
                                        fullWidth
                                        className={classes.formField}
                                        rows={6}
                                        multiline={true}
                                        error={touched.prompt && Boolean(errors.prompt)}
                                        helperText={(touched.prompt && errors.prompt) || i18n.t("promptModal.fields.mainPromptHelper")}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color="primary"
                                                        startIcon={<Fullscreen />}
                                                        className={classes.expandedPromptButton}
                                                        onClick={() => {
                                                            setExpandedPromptText(values.prompt || "");
                                                            setExpandedPromptChanged(false);
                                                            setExpandedPromptModalOpen(true);
                                                        }}
                                                        style={{ fontSize: '11px', padding: '4px 8px', marginRight: 8 }}
                                                    >
                                                        {i18n.t("promptModal.buttons.expand")}
                                                    </Button>
                                                </InputAdornment>
                                            )
                                        }}
                                        placeholder={i18n.t("promptModal.fields.mainPromptPlaceholder")}
                                    />
                                    <Box display="flex" justifyContent="flex-end" marginTop={0.5}>
                                        <Typography variant="caption" color="textSecondary">
                                            {i18n.t("promptModal.fields.charCount", { count: (values.prompt || "").length })}
                                        </Typography>
                                    </Box>
                                </Paper>
                                
                                {/* ✅ SECCIÓN: CONFIGURACIÓN AVANZADA */}
                                <Paper className={classes.formSection}>
                                    <Typography className={classes.sectionTitle}>
                                        <Settings style={{ marginRight: 8 }} />
                                        {i18n.t("promptModal.sections.advanced")}
                                    </Typography>
                                    
                                    <div className={classes.multFieldLine}>
                                        <TextField
                                            label={i18n.t("promptModal.fields.temperature")}
                                            name="temperature"
                                            value={values.temperature || ""}
                                            onChange={(e) => setFieldValue('temperature', e.target.value)}
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            className={classes.formField}
                                            error={touched.temperature && Boolean(errors.temperature)}
                                            helperText={(touched.temperature && errors.temperature) || i18n.t("promptModal.fields.temperatureHelper")}
                                            inputProps={{ min: 0, max: 2, step: 0.1 }}
                                        />
                                        <TextField
                                            label={i18n.t("promptModal.fields.maxTokens")}
                                            name="maxTokens"
                                            value={values.maxTokens || ""}
                                            onChange={(e) => setFieldValue('maxTokens', e.target.value)}
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            className={classes.formField}
                                            error={touched.maxTokens && Boolean(errors.maxTokens)}
                                            helperText={(touched.maxTokens && errors.maxTokens) || i18n.t("promptModal.fields.maxTokensHelper")}
                                            inputProps={{ min: 1, max: 4000 }}
                                        />
                                        <TextField
                                            label={i18n.t("promptModal.fields.maxMessages")}
                                            name="maxMessages"
                                            value={values.maxMessages || ""}
                                            onChange={(e) => setFieldValue('maxMessages', e.target.value)}
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                            type="number"
                                            className={classes.formField}
                                            error={touched.maxMessages && Boolean(errors.maxMessages)}
                                            helperText={(touched.maxMessages && errors.maxMessages) || i18n.t("promptModal.fields.maxMessagesHelper")}
                                            inputProps={{ min: 1, max: 100 }}
                                        />
                                    </div>
                                    
                                    <FormControl fullWidth margin="dense" variant="outlined" className={`${classes.formField} ${classes.formControlDynamic}`}>
                                        <InputLabel>{i18n.t("promptModal.fields.queueOptional")}</InputLabel>
                                        <Select
                                            label={i18n.t("promptModal.fields.queueOptional")}
                                            name="queueId"
                                            variant="outlined"
                                            margin="dense"
                                            fullWidth
                                            value={values.queueId || ""}
                                            onChange={(e) => setFieldValue("queueId", e.target.value)}
                                        >
                                            <MenuItem value="">
                                                <em>{i18n.t("promptModal.fields.noQueue")}</em>
                                            </MenuItem>
                                            {Array.isArray(user?.queues) && user.queues.map((queue) => (
                                                <MenuItem key={queue.id} value={queue.id}>
                                                    {queue.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Paper>
                                
                                {/* ✅ SECCIÓN: ARCHIVOS MULTIMEDIA */}
                                <PromptMediaSection
                                    classes={classes}
                                    promptId={promptId}
                                    mediaFiles={mediaFiles}
                                    loadingMedia={loadingMedia}
                                    mediaMessage={mediaMessage}
                                    isDragging={isDragging}
                                    setUrlModalOpen={setUrlModalOpen}
                                    fileInputRef={fileInputRef}
                                    handleFileUpload={handleFileUpload}
                                    handleDeleteMedia={handleDeleteMedia}
                                    handleReorder={handleReorder}
                                />

                                {/* ✅ FASE 3: MODO DE TRABAJO + gestor condicional layers/pdfs */}
                                <PromptWorkModeSection
                                    classes={classes}
                                    promptId={promptId}
                                    companyId={user?.companyId}
                                    selectedWorkMode={selectedWorkMode}
                                    setSelectedWorkMode={setSelectedWorkMode}
                                />
                            </DialogContent>
                            
                            <DialogActions className={classes.dialogActions}>
                                <Button
                                    onClick={handleClose}
                                    disabled={isSubmitting}
                                    className={classes.cancelButton}
                                >
                                    {i18n.t("promptModal.buttons.cancelUpper")}
                                </Button>
                                <Button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={classes.saveButton}
                                >
                                    {promptId
                                        ? `${i18n.t("promptModal.buttons.okEdit")}`
                                        : `${i18n.t("promptModal.buttons.okAdd")}`}
                                    {isSubmitting && (
                                        <CircularProgress
                                            size={24}
                                            className={classes.buttonProgress}
                                        />
                                    )}
                                </Button>
                            </DialogActions>
                        </Form>
                        );
                    }}
                </Formik>
            </Dialog>
            
            {/* ✅ MODAL PARA AGREGAR URL EXTERNA */}
            <Dialog
                open={urlModalOpen}
                onClose={() => setUrlModalOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle className={classes.dialogTitle}>
                    <Box display="flex" alignItems="center">
                        <LinkIcon style={{ marginRight: 12, fontSize: 28 }} />
                        <Typography variant="h6">
                            {i18n.t("promptModal.urlDialog.title")}
                        </Typography>
                    </Box>
                </DialogTitle>
                <UrlModalContent
                    onAdd={handleAddUrl}
                    onClose={() => setUrlModalOpen(false)}
                    loading={loadingMedia}
                    classes={classes}
                />
            </Dialog>
            
            {/* ✅ MODAL AMPLIADO PARA EDITAR PROMPT */}
            {expandedPromptModalOpen && (
                <ExpandedPromptModal
                    open={expandedPromptModalOpen}
                    promptText={expandedPromptText}
                    onClose={() => {
                        if (expandedPromptChanged) {
                            if (window.confirm(i18n.t("promptModal.expanded.confirmClose"))) {
                                handleSaveExpandedPrompt();
                            } else {
                                setExpandedPromptModalOpen(false);
                                setExpandedPromptChanged(false);
                            }
                        } else {
                            setExpandedPromptModalOpen(false);
                        }
                    }}
                    onSave={(newText) => {
                        // Actualizar el campo del formulario usando setFieldValue de Formik
                        // Necesitamos pasar setFieldValue desde el render de Formik
                        handleSaveExpandedPrompt(newText);
                    }}
                    onChange={(newText) => {
                        setExpandedPromptText(newText);
                        setExpandedPromptChanged(true);
                    }}
                    hasChanges={expandedPromptChanged}
                    classes={classes}
                />
            )}
        </div>
    );
    
    // ✅ FUNCIÓN PARA GUARDAR CAMBIOS DEL MODAL AMPLIADO
    function handleSaveExpandedPrompt(newText = null) {
        const textToSave = newText || expandedPromptText;
        // Usar setFieldValue de Formik si está disponible
        if (window.setFieldValuePrompt) {
            window.setFieldValuePrompt('prompt', textToSave);
        } else {
            // Fallback: actualizar directamente el campo
            const formikForm = document.querySelector('form');
            if (formikForm) {
                const promptInput = formikForm.querySelector('textarea[name="prompt"]');
                if (promptInput) {
                    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                        window.HTMLTextAreaElement.prototype,
                        "value"
                    )?.set;
                    if (nativeInputValueSetter) {
                        nativeInputValueSetter.call(promptInput, textToSave);
                    }
                    const event = new Event('input', { bubbles: true });
                    promptInput.dispatchEvent(event);
                }
            }
        }
        setExpandedPromptModalOpen(false);
        setExpandedPromptChanged(false);
        toast.success(i18n.t("promptModal.expanded.toastSaved"));
    }
};

// ✅ COMPONENTE SEPARADO PARA EL MODAL AMPLIADO DE PROMPT
export default PromptModal;